'use client';

import { c as _c } from "react/compiler-runtime";
import { createSubscriberQueryFn, getSubscriberQueryMetaOptions, isUserPortfolioSnapshotWire, type UseQueryResult, type UserPortfolioSnapshotWire, type UserPortfolioUnvalidatedValue, useIsFetchedThisSession, useQuery, useQueryClient } from '@morfi/backend-sdk-v2/client';
import { useMemo } from 'react'; // ARBITRARY: TanStack Query requires stable observer identities.
import { userPortfolioSnapshotQueryKey } from './query-key';
export function useUserPortfolioSnapshotQuerySelect(userId, select) {
  const $ = _c(2);
  let t0;
  if ($[0] !== select) {
    t0 = guardedSnapshotSelect(select);
    $[0] = select;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const guardedSelect = t0;
  return useUserPortfolioSnapshotQueryObserver(userId, guardedSelect);
}

/** False while the snapshot is only a persisted copy from a previous session. */
export function useUserPortfolioSnapshotFetchedThisSession(userId) {
  const $ = _c(2);
  let t0;
  if ($[0] !== userId) {
    t0 = userPortfolioSnapshotQueryKey(userId);
    $[0] = userId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useIsFetchedThisSession(t0);
}
function useUserPortfolioSnapshotQueryObserver(userId, select) {
  const $ = _c(13);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== userId) {
    t0 = userPortfolioSnapshotQueryKey(userId);
    $[0] = userId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const queryKey = t0;
  let t1;
  if ($[2] !== queryClient || $[3] !== queryKey) {
    t1 = subscriberQueryFn(queryClient, queryKey);
    $[2] = queryClient;
    $[3] = queryKey;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const queryFn = t1;
  let t2;
  if ($[5] !== queryClient || $[6] !== queryKey) {
    t2 = getSubscriberQueryMetaOptions(queryClient, queryKey);
    $[5] = queryClient;
    $[6] = queryKey;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== queryFn || $[9] !== queryKey || $[10] !== select || $[11] !== t2) {
    t3 = {
      queryKey,
      queryFn,
      ...t2,
      enabled: false,
      staleTime: Number.POSITIVE_INFINITY,
      select
    };
    $[8] = queryFn;
    $[9] = queryKey;
    $[10] = select;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return useQuery(t3);
}
function guardedSnapshotSelect<TSelected>(select: (snapshot: UserPortfolioSnapshotWire | null) => TSelected): (snapshot: UserPortfolioUnvalidatedValue) => TSelected {
  return (snapshot: UserPortfolioUnvalidatedValue): TSelected => select(isUserPortfolioSnapshotWire(snapshot) ? snapshot : null);
}
function subscriberQueryFn(queryClient: Parameters<typeof createSubscriberQueryFn<UserPortfolioUnvalidatedValue>>[0], queryKey: Parameters<typeof createSubscriberQueryFn<UserPortfolioUnvalidatedValue>>[1]): ReturnType<typeof createSubscriberQueryFn<UserPortfolioUnvalidatedValue>> {
  return createSubscriberQueryFn<UserPortfolioUnvalidatedValue>(queryClient, queryKey);
}